/**
 * @fileoverview TimeOfDayToggle — a person's "log against the clock" switch
 * on the weekly timesheet toolbar (MOR-935).
 *
 * Optional per person, which was Oscar's explicit ask: some of WLPR's people
 * want the sequence of their day, others post everything to the day and do
 * not want to be asked for a time. The setting is theirs, not the firm's.
 */

import { useMutation } from "convex/react";
import { toast } from "sonner";

import { api } from "@cvx/_generated/api";
import type { Id } from "@cvx/_generated/dataModel";

import { extractErrorMessage } from "@/utils/errors";
import { Label } from "@/ui/primitives";
import { Switch } from "@/ui/primitives/switch";

export function TimeOfDayToggle({
  orgId,
  showTimeOfDay,
}: {
  orgId: Id<"organizations">;
  showTimeOfDay: boolean;
}) {
  const setMyPreferences = useMutation(
    api.timesheets.profiles.setMyPreferences,
  );
  return (
    <div className="flex items-center gap-2">
      <Switch
        id="show-time-of-day"
        checked={showTimeOfDay}
        onCheckedChange={(checked) =>
          void setMyPreferences({ orgId, showTimeOfDay: checked }).catch(
            (err: unknown) =>
              toast.error(extractErrorMessage(err, "Could not save that.")),
          )
        }
      />
      <Label
        htmlFor="show-time-of-day"
        className="text-xs text-muted-foreground"
      >
        Show times
      </Label>
    </div>
  );
}
